import React from 'react';
import { Icon } from 'src/components/Icons';
import { HamburgerDropdown, HamburgerBadge } from './HamburgerMenu.styles';
import { ITheme } from './interfaces';
import { t } from 'i18next';

interface Props {
  awaitingSigningCasesCount: number;
  isOpen: boolean;
}

const PortalHamburgerButton = ({
  awaitingSigningCasesCount,
  isOpen,
  ...rest
}: ITheme & Props) => (
  <HamburgerDropdown {...rest}>
    <HamburgerBadge
      max={9}
      color="primary"
      isOpen={isOpen}
      badgeContent={awaitingSigningCasesCount}
    >
      <Icon type="menu" aria-label={t('MainNavigationButtonLabel')} />
    </HamburgerBadge>
  </HamburgerDropdown>
);

export default PortalHamburgerButton;
